export const Subscription = () => {
  return (
    <div className='px-8 mt-8 sm:mt-8 mb-8 sm:my-0 sm:p-8'>
      <div className='flex flex-col justify-center items-center max-w-[600px] m-auto'>
        {/* <h3 className='text-xl text-indigo font-medium mb-8'>
          Business Support Service
        </h3> */}

        <p className='mb-4 text-center'>
          Our business mentorship program provides expert guidance and support
          to entrepreneurs and businesses, helping them navigate the challenges
          of starting and growing a successful business. With a team of
          experienced mentors and industry experts, we offer valuable insights
          and practical advice to help businesses achieve their goals and reach
          their full potential. Our mentorship program covers practical coaching
          on Finance, Real Estate and Web.3 including other bonuses on business
          strategy, marketing, finance, operations and management.
        </p>

        {/* <div className='mb-8 flex h-[48px] sm:w-[480px] bg-slate-100 items-center justify-between rounded-md pl-2 pr-[1px] py-2 border-[1px]'>
          <input
            type='email'
            placeholder='ENTER YOUR EMAIL'
            className='h-[46px] w-full text-sm border-none bg-slate-100 outline-0 focus:outline-0 focus:border-none border-transparent focus:border-transparent focus:ring-0 number-input'
          />
          <button
            type='submit'
            className={`flex items-center justify-center bg-indigo hover:bg-yellow text-sm h-[44px] w-[240px] p-2 rounded-md text-white text-transform: uppercase shadow-all-sides`}
          >
            Subscribe
          </button>
        </div> */}
      </div>
    </div>
  );
};
